import { render, staticRenderFns } from "./customopenstreetmap.vue?vue&type=template&id=2d5e5186&"
import script from "./customopenstreetmap.vue?vue&type=script&lang=js&"
export * from "./customopenstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5e5186')) {
      api.createRecord('2d5e5186', component.options)
    } else {
      api.reload('2d5e5186', component.options)
    }
    module.hot.accept("./customopenstreetmap.vue?vue&type=template&id=2d5e5186&", function () {
      api.rerender('2d5e5186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYuE96YCDUxt/JS/comp/customopenstreetmap.vue"
export default component.exports